// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "OidcSsoConfig" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { AadGroupRoleMappingGenShape } from "./aad-group-role-mapping.gen";
import { TenantInfoSyncStatus } from "./tenant-info-sync-status.enum.gen";

export const OidcSsoConfigGenShape = z.strictObject({
  azureAdTenantId: z.string().optional(),
  tenantDomain: z.string().optional(),
  groupRoleMap: z.array(AadGroupRoleMappingGenShape).optional(),
  tenantInfoSyncStatus: z.enum(TenantInfoSyncStatus).optional(),
  tenantInfoSyncFailureReason: z.string().optional(),
  lastSuccessfulTestAt: z.string().optional(),
});
